import api from "./API"

export const getSectionDetail = async (id, section) => {
  return await api.get(
    `get-section-detail?user_id=${id}&user_type=vendor&section=${section}`
  )
}
